export interface LinkObj {
  url: any;
  name: string;
}

export interface HeadElement {
  value: string;
  type: string;
  key: any;
  condition: any;
  links: any;
  tooltip: any;
  tooltipName: string
}

export enum userRoles {
  SuperMaster = 1,
  Master = 2,
  Agent = 3,
  User = 4,
}